module.exports = __webpack_public_path__ + "static/media/logo.e35409f4.svg";